import React, { useState } from "react";
import {
  ArrayField,
  Datagrid,
  FunctionField,
  ReferenceField,
  TextField,
  useDataProvider,
  useNotify,
  useRefresh,
} from "react-admin";
import { Button, Grid, Typography, Box } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { settings } from "app";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import SchoolGradesForm from "./SchoolGradesForm";
import { getTheme } from "customStyles/utils";
import { candidateRequests } from "api/candidateApi";

const SchoolGrades = ({ userId, candidacyId, hasApprovedRanking }) => {
  const userPermissions = getPermissions();
  const canEdit = checkPermission(userPermissions, permissions.canAddSchoolSubjectGrades);

  const [userGrades, setUserGrades] = useState({});
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const theme = getTheme(settings.tenant);

  const handleSaveGrades = async () => {
    const schoolSubjectGrades = Object.entries(userGrades)
      .filter(([, grade]) => grade !== null && grade !== undefined && grade !== "")
      .map(([schoolSubjectId, grade]) => ({
        schoolSubjectId: schoolSubjectId,
        grade: parseFloat(grade),
      }));

    await dataProvider.customRequest(
      candidateRequests.userSchoolSubjectGrades(userId),
      { userId, schoolSubjectGrades },
      "POST",
    );
    notify("Оценките са запазени успешно", { type: "success" });
    refresh();
  };

  const EditTriggerButton = (
    <Button
      startIcon={<EditIcon />}
      variant="contained"
      sx={{ marginBottom: "1rem", fontSize: 12 }}
      disabled={!canEdit || hasApprovedRanking}
    >
      Годишни оценки от дипломата
    </Button>
  );

  return (
    <Grid
      item
      xs={12}
    >
      <Typography
        fontWeight={600}
        color={"#4E2683"}
      >
        Оценки от училище
      </Typography>
      <ArrayField source="schoolGrades">
        <Datagrid
          rowClick={false}
          bulkActionButtons={false}
          sx={settings.style.secondaryDatagrid}
        >
          <ReferenceField
            label="Предмет"
            source="schoolSubjectId"
            reference={candidateRequests.getSchoolSubjectsSelect()}
          >
            <TextField
              source="nameBg"
              emptyText="-"
            />
          </ReferenceField>
          <FunctionField
            render={rec => (
              <TextField
                color={+rec.grade === 2 ? theme.palette.error.primary : null}
                label="Оценка"
                source="grade"
                emptyText="-"
              />
            )}
          />
        </Datagrid>
      </ArrayField>

      <Box mt={1}>
        <ConfirmModal
          titleContent="Промяна на годишни оценки от дипломата"
          onConfirm={canEdit ? handleSaveGrades : undefined}
          triggerButton={EditTriggerButton}
        >
          <SchoolGradesForm
            candidacyId={candidacyId}
            userId={userId}
            initialGrades={userGrades}
            onGradesChange={setUserGrades}
          />
        </ConfirmModal>
      </Box>
    </Grid>
  );
};

export default SchoolGrades;
